<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input
            v-model="queryParam.keyWord"
            placeholder="搜索关键字"
            allowClear
          >
            <a-select
              slot="addonBefore"
              v-model="queryParam.searchType"
              placeholder="搜索类型"
              style="width: 120px"
            >
              <a-select-option
                :value="item.id"
                :key="item.id"
                v-for="item in dict.searchTypeDict"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-form-item class="mr-20">
          <a-select v-model="queryParam.status" allowClear placeholder="状态" style="width: 180px">
            <a-select-option
              :value="item.id"
              :key="item.id"
              v-for="item in dict.statusDict"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleAdd"
        >新增商品</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <a-tag slot="status" slot-scope="text" :color="text==='NORMAL'?'green':'orange'">
          {{ text | valInDict(dict.statusDict) }}
        </a-tag>
        <span
          slot="action"
          slot-scope="text, record"
        >
          <a-button
            type="link"
            @click="handleEdit(record.goods_id)"
          >编辑</a-button>
          <a-button
            type="link"
            @click="handleDelete(record.goods_id)"
          >删除</a-button>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
  </div>
</template>

<script>
import { TcgTable } from '@/components'
import { getGoodsPre, getGoodsList, postGoodsDel } from '@/api/goods'

const defaultQueryParam = {
  searchType: 'name'
}

export default {
  name: 'GoodsList',
  components: { TcgTable },
  data() {
    return {
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        searchTypeDict: [{ id: 'name', name: '商品名称' }, { id: 'id', name: '商品ID' }, { id: 'category', name: '商品分类' }],
        statusDict: [{ id: 'NORMAL', name: '正常' }, { id: 'FORBIDDEN', name: '下架' }]
      },
      columns: [
        {
          title: '商品ID',
          dataIndex: 'goods_id',
          width: '80px'
        },
        {
          title: '商品名称',
          dataIndex: 'name'
        },
        {
          title: '所属品牌',
          dataIndex: 'brand_name',
          width: '100px'
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '80px'
        },
        {
          title: '分类',
          dataIndex: 'category_str'
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: '80px',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          width: '150px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getGoodsList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      }
    }
  },
  created() {
    this.getPre()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 通过 `vm` 访问组件实例
      if (from.name === 'goodsEdit' || from.name === 'goodsAdd') {
        vm.$refs.table.refresh(true)
      }
    })
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.$refs.table.refresh(true)
    },
    handleAdd() {
      this.$router.push({ name: 'goodsAdd' })
    },
    handleEdit(id) {
      this.$router.push({ name: 'goodsEdit', query: { id } })
    },
    handleDelete(id) {
      this.$confirm({
        title: '确定要删除?',
        onOk: () => {
          postGoodsDel({
            goods_id: id
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功')
                this.$refs.table.refresh(true)
              }
            })
            .catch((e) => {
              this.$message.error('删除失败')
            })
        }
      })
    },
    // 预加载
    getPre() {
      getGoodsPre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.statusDict = data.statusDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
